import React from 'react';

import './copy-right.scss';

const CopyRight = () => {
  const year = new Date().getFullYear();

  return (
    <span className="sm-copy-right">{`Copyright © 1999-${year} SurveyMonkey`}</span>
  );
};

export default CopyRight;
